import { useState } from 'react';
import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { VendorProfileSettingsContainerRenderProps } from 'modules/portalConfigurations/types';

export default function OcaLenderSettings({
  vpSettings,
  onSaveVendorProfile,
}: VendorProfileSettingsContainerRenderProps) {
  const [ocaShowCookieConsentBanner, setOcaShowCookieConsentBanner] = useState(!!vpSettings.ocaShowCookieConsentBanner);

  // TODO: rework to user React Hook Form
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            checked={ocaShowCookieConsentBanner}
            onChange={async event => {
              setOcaShowCookieConsentBanner(event.target.checked);
              await onSaveVendorProfile({ ocaShowCookieConsentBanner: event.target.checked });
            }}
          />
        }
        label="Show Cookie Consent Banner"
      />
    </FormGroup>
  );
}
